import { useState, useParams, ToastContainer, BiRupee, FaTimes } from '../../common/common';
import useNavigation from '../../common/useNavigation';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import MidPlans from '../../middleware/plans/MidPlans';
import { FaCheck, FaUser } from 'react-icons/fa6';
import { AiOutlineClose } from 'react-icons/ai';
import { FiAlertTriangle } from 'react-icons/fi';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { useEffect } from 'react';

const Plans = () => {

    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);

    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, subUser, isAnnual, isINR, Mainplans, userPlanDetails , setIsINR} = MidPlans(type);

    const { navigatePlanCart } = useNavigation();

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users?.[0]?.['AppID'] ;
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var ActiveUser = users[0]["Status"];
        var currentPlan = users[0]["PurchasedPlanID"];
        // var users =
    }


    const [selectedPlan, setSelectedPlan] = useState([]);
    const [currentPlans, setCurrentPlans] = useState([]);

    const uniqueFeaturess = [
        "Selzor Branded Web & Mobile App (Android)",
        "Seller (Company / Organisation)",
        "Users Included (Admin Account)",
        "Total Orders",
        "Buyers / Customers",
        "Custom Order Fields"
    ];

    const [isOpen, setIsOpen] = useState(false);
    const [userModalOpen, setUserModalOpen] = useState(false);

    const [orders, setOrders] = useState({
        totalUsersCount: 0,
        usedUserCounts: 0,
    })


    const fetchAllOrdersData = async () => {
        try {
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetAllOrdersCounts`, {}, { withCredentials: true });
            // console.log(response.data);
            setOrders({
                totalUsersCount: response.data.responseData.userTotalCounts,
                usedUserCounts: response.data.responseData.usedUserCounts,
            })
        } catch (err) {
            // console.error("Failed to load new orders, please try again later ", err);
        } finally {
            // showToast("Something Went Wrong !!!" , 'error')
        }

    };

    useEffect(() => {
        showToast('', '');
        fetchAllOrdersData();
    }, []);

    const handleCheckCurrentPlan = (plans, cur) => {

        const current_plan_filter = Mainplans.filter((currentplans) => currentplans.plan_name === currentPlan);

        if (current_plan_filter.length > 0) {

            setCurrentPlans(current_plan_filter);
            const current_plan_id = current_plan_filter[0]["id"];

            let selected_plan_id = plans.id;

            if (current_plan_id > selected_plan_id) {
                setSelectedPlan(plans);
                setIsOpen(true);
            }
            else {
                navigatePlanCart(plans.unique_id, cur);
            }
        }
        else {
            navigatePlanCart(plans.unique_id, cur);
        }
    }

    const handleUsersCheck = () => {

        const select_plan_users = selectedPlan.plan_user;
        const current_plan_user = currentPlans[0]?.plan_user;

        const current_total_usesr = orders.totalUsersCount;
        const used_users = orders.usedUserCounts; // a mukvu

        const users_calculate = current_total_usesr - current_plan_user;

        const new_users_added = users_calculate + select_plan_users;

        if (new_users_added >= used_users) {
            navigatePlanCart(selectedPlan.unique_id, isINR);
        }
        else {

            navigatePlanCart(selectedPlan.unique_id, isINR);
            setIsOpen(false);
            // handleModalOpen();
        }
    }

    const [selectedUsers, setSelectedUsers] = useState([]);

    // Checkbox toggle
    const handleCheckboxChange = (user) => {
        if (selectedUsers.find((u) => u.id === user.id)) {
            // Agar already selected hai to remove karega
            setSelectedUsers(selectedUsers.filter((u) => u.id !== user.id));
        } else {
            // Naya select karte time required fields add karega
            setSelectedUsers([
                ...selectedUsers,
                {
                    id: user.id,
                    user_unique_id: user.user_unique_id,
                    parent_user_id: user.parent_user_id
                }
            ]);
        }
    };

    const handleInActiveUser = async (e) => {
        e.preventDefault();

        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/planInUserInActive`,
                { users: selectedUsers },
                { withCredentials: true }
            );

            if (response.data.success === 1) {
                navigatePlanCart(selectedPlan.unique_id, isINR);
                showToast(response.data.message, 'success');
            } else {
                showToast(response.data.message, 'warning'); // success nahi to warning show karo
            }

        } catch (err) {
            showToast(err.response?.data?.message || "Something Went Wrong !!!", 'error');
        }
    };



    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />

                <div className="grid grid-cols-12">
                    <div className="col-start-1 col-end-13">
                        <div className="">
                            <div className=" p-2 text-xl text-[#1e3a8a]">
                                <div className='px-3'>
                                    <h1 className=' text-lg text-theme-color-text font-bold'> Clear and transparent pricing, no hidden fees</h1>
                                    <p className=' text-gray-600 text-[16px] '> Selzor's pricing is straightforward and transparent — no unexpected charges.</p>
                                </div>
                            </div>
                        </div>

                        <div className="border-0 flex-row rounded-xl m-3 p-4 bg-white shadow-xs">
                            <div className=' relative flex flex-col min-w-0 break-words'>
                                <div className=''>
                                    <div>
                                        {/* <Header /> */}
                                        <section className='mx-auto max-w-screen-2xl'>
                                            <div className="bg-white ">

                                                <div className="flex justify-end">
                                                    <div className="flex justify-center max-w-[175px] w-full mb-5 lg:mb-16">
                                                        <div className="relative flex w-full p-1 bg-white dark:bg-slate-900 rounded-full border-[1px] border-solid border-[#fdb74b]">
                                                            <span className="absolute inset-0 m-1 pointer-events-none" aria-hidden="true">
                                                                <span className={`absolute inset-0 w-1/2 bg-gradient-to-r from-theme-color-start to-theme-color-end text-[#4b2402] font-semibold uppercase border-0 rounded-full shadow-sm shadow-indigo-950/10 transform transition-transform duration-150 ease-in-out ${isINR ? 'translate-x-0' : 'translate-x-full'}`} />
                                                            </span>
                                                            <button className={`relative flex-1 text-sm font-medium h-8 rounded-full ${isINR ? 'text-[#4b2402]' : 'text-slate-500 dark:text-slate-400'}`} onClick={() => setIsINR(true)}>
                                                                INR
                                                            </button>
                                                            <button className={`relative flex-1 text-sm font-medium h-8 rounded-full ${!isINR ? 'text-[#4b2402]' : 'text-slate-500 dark:text-slate-400'}`} onClick={() => setIsINR(false)}>
                                                                Dollar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="pricingPlanTableArea hidden md:block">
                                                    <div className="pricingTableForDesktop">

                                                        <table className="price-table w-full border-collapse">
                                                            <thead>
                                                                <tr className="price-header-tr">
                                                                    <td className="border-b border-gray-200"></td>
                                                                    {Mainplans.map((planss) => (
                                                                        <td key={planss.id} className="price border-b border-gray-200 p-6 text-center">
                                                                            <h4 className="text-xl sm:text-3xl font-medium pb-2 sm:pb-3 text-gray-700">
                                                                                {planss.plan_name}
                                                                            </h4>
                                                                            <div className="price price1 mb-4">
                                                                                <span className="currency font-bold text-3xl">

                                                                                    <div className="inline-flex items-baseline mb-2">
                                                                                        <span className="text-slate-500 font-medium">
                                                                                            {isINR ? <BiRupee /> : '$'}
                                                                                        </span>

                                                                                        <span className="text-slate-500 font-medium">
                                                                                            {isAnnual
                                                                                                ? (isINR ? planss.inr_price_monthly * 12 : planss.price_monthly * 12)
                                                                                                : (isINR ? planss.inr_price_monthly : planss.price_monthly)
                                                                                            }
                                                                                        </span>
                                                                                        {/* <span className="text-slate-500 font-medium">/mo</span> */}
                                                                                    </div>
                                                                                    {/* {planss.is_inr ? `₹${planss.inr_price_monthly}` : `$${planss.price_monthly}`} */}
                                                                                </span>
                                                                            </div>

                                                                            <div>
                                                                                {userPlanDetails.length > 0 ? (
                                                                                    userPlanDetails[0].plan_name === planss.plan_name ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="w-full inline-flex justify-center whitespace-nowrap rounded-lg bg-[#707070] px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-[#707070] focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 cursor-not-allowed"
                                                                                            disabled
                                                                                        >
                                                                                            Current Plan
                                                                                        </button>
                                                                                    ) : (
                                                                                        <div>
                                                                                            {isINR ? (
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="w-full inline-flex justify-center whitespace-nowrap rounded-lg  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 bg-button-color  hover:bg-button-color focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150"
                                                                                                    onClick={() => handleCheckCurrentPlan(planss, isINR)}
                                                                                                >
                                                                                                    Upgrade Plan
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button
                                                                                                    disabled
                                                                                                    type="button"
                                                                                                    className="w-full inline-flex justify-center whitespace-nowrap rounded-lg  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 bg-gray-400  hover:bg-gray-400 focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 cursor-not-allowed"

                                                                                                >
                                                                                                    Upgrade Plan
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    )
                                                                                ) : null}
                                                                            </div>
                                                                            
                                                                            <small className="text-xs italic text-gray-500 block">Additional charges may apply</small>

                                                                            
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            </thead>


                                                            <tbody>
                                                                {uniqueFeaturess.map(feature => (
                                                                    <tr key={feature} className="price-table-body-tr border-b border-gray-200">
                                                                        <td className="p-4 font-medium text-start">{feature}</td>

                                                                        {Mainplans.map(plan => {
                                                                            let valueToShow = null;

                                                                            // Feature wise data mapping
                                                                            if (feature.includes("Users Included")) {
                                                                                valueToShow = plan.plan_user;
                                                                            } else if (feature.includes("Total Orders")) {
                                                                                valueToShow = plan.plan_orders;
                                                                            } else if (feature.includes("Buyers / Customers")) {
                                                                                valueToShow = plan.buyers;
                                                                            } else if (feature.includes("Custom Order Fields")) {
                                                                                valueToShow = plan.custome_field;
                                                                            }

                                                                            return (
                                                                                <td key={plan.id} className="border p-3 text-center">
                                                                                    {valueToShow !== null ? (
                                                                                        <span className="font-semibold">{valueToShow}</span>
                                                                                    ) : (
                                                                                        // Selzor App & Seller => Always True
                                                                                        (feature.includes("Selzor") || feature.includes("Seller")) ? (
                                                                                            <FaCheck className="text-green-500 mx-auto" />
                                                                                        ) : (
                                                                                            <FaTimes className="text-red-500 mx-auto" />
                                                                                        )
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="pricingTableForMobile md:hidden">
                                                    <div className="pricingTableBoxArea">
                                                        <div className="grid grid-cols-1 gap-6">

                                                            {Mainplans.map((plan) => (
                                                                <div key={plan.id} className="pricingTableBox border border-gray-200 rounded-lg overflow-hidden">
                                                                    <div className="pricingTableBoxinner">
                                                                        <div className="pricingTableLabel bg-purple-100 text-purple-800 py-2 px-4 font-bold">
                                                                            {plan.plan_name}
                                                                        </div>
                                                                        <div className="p-6">
                                                                            {/* Price */}
                                                                            <div className="price price1 mb-4 text-center">
                                                                                <div className='flex'>
                                                                                    <span className="currency font-bold text-3xl">
                                                                                        {isINR ? <BiRupee /> : '$'}
                                                                                    </span>

                                                                                    <span className="currency font-bold text-3xl">

                                                                                        {isAnnual
                                                                                            ? (isINR ? plan.inr_price_monthly * 12 : plan.price_monthly * 12)
                                                                                            : (isINR ? plan.inr_price_monthly : plan.price_monthly)
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="pricingTableFeatures space-y-4 mb-6">
                                                                                {uniqueFeaturess.map((feature, index) => {

                                                                                    let valueToShow = null;

                                                                                    // Feature wise data mapping
                                                                                    if (feature.includes("Users Included")) {
                                                                                        valueToShow = plan.plan_user;
                                                                                    } else if (feature.includes("Total Orders")) {
                                                                                        valueToShow = plan.plan_orders;
                                                                                    } else if (feature.includes("Buyers / Customers")) {
                                                                                        valueToShow = plan.buyers;
                                                                                    } else if (feature.includes("Custom Order Fields")) {
                                                                                        valueToShow = plan.custome_field;
                                                                                    }

                                                                                    return (
                                                                                        <div key={index} className="pricingTableFeaturesItem">
                                                                                            <div className="flex justify-between items-center text-start">
                                                                                                <div className="leftSide">
                                                                                                    <p className="mb-0 font-medium">{feature}</p>
                                                                                                </div>
                                                                                                <div className="rightSide">
                                                                                                    {valueToShow !== null ? (
                                                                                                        <span>{valueToShow}</span>
                                                                                                    ) : (feature.includes("Selzor") || feature.includes("Seller")) ? (
                                                                                                        <FaCheck className="text-green-500" />
                                                                                                    ) : (
                                                                                                        <FaTimes className="text-red-500" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}

                                                                                {/* Total Price Footer */}
                                                                                <div className="pricingTableFeaturesItem total pt-4 border-t border-gray-200">
                                                                                    <div className="flex justify-between items-center text-start">
                                                                                        <div className="leftSide">
                                                                                            <p className="mb-0 font-bold">Total</p>
                                                                                        </div>
                                                                                        <div className="rightSide">
                                                                                            {plan.is_inr ? `₹${plan.inr_price_monthly * 12}` : `$${plan.price_monthly * 12}`} / year
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* CTA Button */}
                                                                            <div>
                                                                                {userPlanDetails.length > 0 ? (
                                                                                    userPlanDetails[0].plan_name === plan.plan_name ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="w-full inline-flex justify-center whitespace-nowrap rounded-lg bg-[#707070] px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-[#707070] focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150 cursor-not-allowed"
                                                                                            disabled
                                                                                        >
                                                                                            Current Plan
                                                                                        </button>
                                                                                    ) : (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="w-full inline-flex justify-center whitespace-nowrap rounded-lg  px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 bg-button-color  hover:bg-button-color focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 dark:focus-visible:ring-slate-600 transition-colors duration-150"
                                                                                            onClick={() => navigatePlanCart(plan.unique_id, isINR)}
                                                                                        >
                                                                                            Upgrade Plan
                                                                                        </button>
                                                                                    )
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </section>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                {isOpen && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                        {/* Modal Box */}
                        <div className="bg-white w-96 p-6 rounded-2xl shadow-xl animate-scaleIn relative">
                            {/* Close Button */}
                            <button
                                onClick={() => setIsOpen(false)}
                                className="absolute top-3 right-3 text-gray-500 hover:text-black"
                            >
                                <AiOutlineClose size={20} />
                            </button>

                            {/* Icon */}
                            <div className="flex justify-center mb-4">
                                <FiAlertTriangle className="text-red-500 text-5xl" />
                            </div>

                            {/* Title */}
                            <h2 className="text-xl font-semibold text-center mb-3">
                                Downgrade Confirmation
                            </h2>

                            {/* Message */}
                            <p className="text-gray-600 text-center mb-6">
                                Are you sure you want to downgrade your plan? If you confirm, you can
                                select which users to keep active, and the remaining users will be set
                                to inactive.
                            </p>

                            {/* Action Buttons */}
                            <div className="flex justify-between">
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="w-1/2 mr-2 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 transition"
                                >
                                    Cancel
                                </button>
                                <button onClick={handleUsersCheck} className="w-1/2 ml-2 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition" >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {userModalOpen && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                        {/* Modal Box */}
                        <div className="bg-white max-w-5xl p-6 rounded-2xl shadow-xl animate-scaleIn relative">
                            {/* Close Button */}
                            <button
                                onClick={() => setUserModalOpen(false)}
                                className="absolute top-3 right-3 text-gray-500 hover:text-black"
                            >
                                <AiOutlineClose size={20} />
                            </button>

                            {/* Icon */}


                            {/* Title */}
                            <h2 className="text-xl font-semibold  mb-3">
                                User List
                            </h2>
                            <div className="space-y-4 p-4">
                                {subUser.map((user) => (
                                    <div
                                        key={user.id}
                                        className="flex items-center justify-between p-4 border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 bg-white hover:-translate-y-1"
                                    >
                                        {/* Left Section - User Info */}
                                        <div className="flex items-center space-x-4">
                                            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100">
                                                <FaUser className="text-blue-500 text-xl" />
                                            </div>
                                            <div>
                                                <h3 className="text-lg font-semibold text-gray-800">{user.full_name}</h3>
                                                <p className="text-gray-500 text-sm">{user.email}</p>
                                                <p className="text-gray-500 text-sm">{user.mobile}</p>
                                            </div>
                                        </div>

                                        {/* Right Section - Checkbox */}
                                        <div className='ml-5'>
                                            <input
                                                type="checkbox"
                                                className="w-5 h-5 cursor-pointer accent-blue-500"
                                                onChange={() => handleCheckboxChange(user)}
                                                checked={selectedUsers.some((u) => u.id === user.id)}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Action Buttons */}
                            <div className="flex justify-between">
                                <button
                                    onClick={() => setUserModalOpen(false)}
                                    className="w-1/2 mr-2 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 transition"
                                >
                                    Cancel
                                </button>
                                <button onClick={handleInActiveUser} className="w-1/2 ml-2 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition" >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                )}



            </div>

            <ToastContainer />

            <style>
                {`
          @keyframes scaleIn {
            0% { transform: scale(0.8); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .animate-scaleIn {
            animation: scaleIn 0.3s ease-out forwards;
          }
        `}
            </style>

        </div>
    )
}

export default Plans